import { portalForHostname } from './portalExperience';

/**
 * Canonical origin for absolute URLs in `<meta>` / JSON-LD.
 *
 * IMPORTANT: do NOT use `window.location.origin` directly for SEO tags. The
 * pre-render step (client/scripts/prerender.js) runs Puppeteer against a
 * local server (`http://127.0.0.1:45678`). Whatever absolute URL the React
 * tree emits there gets serialised into the static HTML that Google fetches,
 * so og:url / og:image / @id end up pointing at localhost. That breaks
 * social cards, structured data validation, and self-canonical signals.
 *
 * Resolution order:
 *   1. A registered portal hostname, whose public origin is explicitly configured.
 *   2. `process.env.REACT_APP_SITE_URL` - baked into the bundle at
 *      `react-scripts build` time. Vercel build env or local build flag.
 *   3. `window.location.origin` - only for client-side runtime in a real
 *      browser. Skipped if the host is loopback / localhost so prerender
 *      can't poison snapshots even when (1) is missing.
 *   4. The known production origin as a hard fallback so we never ship
 *      a localhost URL to crawlers.
 *
 * NOTE: Vercel is configured to redirect the bare domain
 * (internationalpropertymarket.com) to the www subdomain via 307. The
 * canonical URL must therefore use the www form so Google doesn't see the
 * bare domain as a competing canonical and split signals across two hosts.
 */
const PRODUCTION_ORIGIN = 'https://www.internationalpropertymarket.com';

function isLocalhostHost(host) {
    if (!host) return false;
    const h = String(host).toLowerCase();
    return h === 'localhost'
        || h.startsWith('localhost:')
        || h === '127.0.0.1'
        || h.startsWith('127.0.0.1:')
        || h === '::1'
        || h.startsWith('[::1]');
}

export function getCanonicalOrigin() {
    const portal = portalForHostname();
    if (portal) return portal.origin;
    const fromEnv = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SITE_URL) || '';
    if (fromEnv) return fromEnv.replace(/\/+$/, '');
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
        if (!isLocalhostHost(window.location.host)) {
            return window.location.origin.replace(/\/+$/, '');
        }
    }
    return PRODUCTION_ORIGIN;
}

const CANONICAL_ORIGIN = getCanonicalOrigin();
export default CANONICAL_ORIGIN;
